'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Loadable = require('UIComponents/decorators/Loadable');

var _Loadable2 = _interopRequireDefault(_Loadable);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeLoadable = function makeLoadable(_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === undefined ? 500 : _ref$delay,
      loader = _ref.loader;
  return (0, _Loadable2.default)({
    delay: delay,
    loader: loader,
    LoadingComponent: function LoadingComponent(_ref2) {
      var pastDelay = _ref2.pastDelay;
      return pastDelay ? _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) : null;
    }
  });
};

var makeAsync = function makeAsync(loader) {
  return makeLoadable({ loader: loader });
};
exports.default = makeAsync;
module.exports = exports['default'];